import ProjectPage from "./pages/project.page";
import ExperiencePage from "./pages/experience.page";
import HeroSection from "./components/herosection";
import Navbar from "./components/navbar";
import About from "./pages/about.page";
import BlogPage from "./pages/blogs.page";
import SkillsPage from "./pages/skills.page";
import BackgroundSource from "./assets/background-grouped.svg";
import ContactPage from "./pages/contact.page";


function App() {
  return (
    <div
      className="bg-[#090E34] h-auto scroll-smooth"
      style={{
        backgroundImage: `url(${BackgroundSource})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right top",
        backgroundSize: "1738px 837px",
      }}
    >
      <Navbar />
      <HeroSection />
      <About />
      <SkillsPage />
      <ProjectPage />
      <ExperiencePage />
      <BlogPage />
      <ContactPage/>
    </div>
  );
}

export default App;
